import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails, serviceActions } from "../assets/serviciosDetalle";
import CapacitacionCourseCatalog from "../components/CapacitacionCourseCatalog";
import mapServiceItem from "../components/mapServiceItem";
import ServiceCta from "../components/ServiceCta";
import ServiceHero from "../components/ServiceHero";
import ServiceSection from "../components/ServiceSection";
import ServiceSectionHead from "../components/ServiceSectionHead";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["capacitacion-laboral"];
const trainingNavTheme = {
    ...serviciosNavTheme,
    primary: "#b45309",
    primaryDark: "#92400e",
    primaryLight: "#fcd34d",
    pale: "rgba(180, 83, 9, 0.08)",
};
const [introSection, catalogSection, modesSection, formatsSection, workflowSection, valueSection, industriesSection] = service.sections;

const formatIcons = {
    "Presencial in-company": "icon-workshop",
    "Virtual sincrónica": "icon-video",
    "E-learning asincrónico": "icon-laptop",
};

const valueIcons = {
    "Doble titulación FISP + UBA": "icon-cap",
    "Cuerpo docente médico": "icon-stethoscope",
    "Programas a medida": "icon-ruler",
    "Contenido multimedia": "icon-tv",
    "Reportes para RRHH": "icon-observatory",
    "Alcance regional": "icon-community",
};

function withIcons(section, iconMap, variant) {
    return {
        ...section,
        variant,
        items: section.items.map((item) => {
            const card = mapServiceItem(item);
            return {
                ...card,
                marker: iconMap[card.title] || "icon-article",
            };
        }),
    };
}

export default function CapacitacionLaboral() {
    return (
        <div className="servicios servicio-detalle service-page-capacitacion-laboral">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref={serviceActions.whatsapp} navTheme={trainingNavTheme} />
            <ServiceHero service={service} />
            <ServiceSection section={{ ...introSection, variant: "training-intro" }} />
            <CapacitacionCourseCatalog section={catalogSection} />
            <ServiceSection section={{ ...modesSection, variant: "training-modes" }} />
            <ServiceSection section={withIcons(formatsSection, formatIcons, "training-modalities")} />
            <ServiceSection section={workflowSection} />
            <ServiceSection section={withIcons(valueSection, valueIcons, "training-value")} />

            <section className="service-detail-section service-section-training-industries">
                <div className="service-detail-inner">
                    <ServiceSectionHead
                        section={{
                            ...industriesSection,
                            text: "Capacitamos equipos de hospitales y clínicas, laboratorios farmacéuticos, obras sociales, prepagas, bancos, financieras, industria manufacturera, empresas de tecnología, retail, comercio, organismos públicos, universidades, consultoras, energía, petróleo, transporte, logística, aseguradoras, medios de comunicación, alimentos, bebidas y estudios jurídicos.",
                        }}
                    />
                </div>
            </section>

            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
